import { api } from "./api";
import { clearAuthFlag } from "../features/auth/utils/authStorage";

export async function logout() {
  try {
    await api.post("/api/logout/");
  } finally {
    clearAuthFlag();
  }
}
